// Mock data for Ultimate Texas Hold'em game

export const INITIAL_MONEY = 1000;

export const TRIPS_PAYOUT = [
  { hand: 'ROYAL FLUSH', payout: '50 to 1' },
  { hand: 'STRAIGHT FLUSH', payout: '40 to 1' },
  { hand: 'QUADS', payout: '30 to 1' },
  { hand: 'FULL HOUSE', payout: '8 to 1' },
  { hand: 'FLUSH', payout: '6 to 1' },
  { hand: 'STRAIGHT', payout: '5 to 1' },
  { hand: 'TRIPS', payout: '3 to 1' },
];

export const BLIND_PAYOUT = [
  { hand: 'ROYAL FLUSH', payout: '500 to 1' },
  { hand: 'STRAIGHT FLUSH', payout: '50 to 1' },
  { hand: 'QUADS', payout: '10 to 1' },
  { hand: 'FULL HOUSE', payout: '3 to 1' },
  { hand: 'FLUSH', payout: '3 to 2' },
  { hand: 'STRAIGHT', payout: '1 to 1' },
  { hand: 'OTHER HANDS', payout: 'Push' },
];

export const DECK = [
  // Hearts
  '2H', '3H', '4H', '5H', '6H', '7H', '8H', '9H', '10H', 'JH', 'QH', 'KH', 'AH',
  // Diamonds
  '2D', '3D', '4D', '5D', '6D', '7D', '8D', '9D', '10D', 'JD', 'QD', 'KD', 'AD',
  // Clubs
  '2C', '3C', '4C', '5C', '6C', '7C', '8C', '9C', '10C', 'JC', 'QC', 'KC', 'AC',
  // Spades
  '2S', '3S', '4S', '5S', '6S', '7S', '8S', '9S', '10S', 'JS', 'QS', 'KS', 'AS',
];

export const RECENT_BIG_WINS = [
  { hand: 'Royal Flush', time: '2 hours ago', location: 'Paris, FR', winnings: '$12,800' },
  { hand: 'Straight Flush', time: '11 minutes ago', location: 'Lyon, FR', winnings: '$2,000' },
  { hand: 'Quads', time: '5 minutes ago', location: 'Marseille, FR', winnings: '$1,500' },
];

export const LEADERBOARD = [
  { name: 'Player1', trips: 100, ante: 50, buyIn: 500 },
  { name: 'Player2', trips: 80, ante: 40, buyIn: 400 },
  { name: 'Player3', trips: 60, ante: 30, buyIn: 300 },
];

export const BET_AMOUNTS = [5, 10, 25, 50, 100];

export const RESET_AMOUNTS = [100, 1000, 10000];

export const HAND_RANKINGS = {
  'Royal Flush': 10,
  'Straight Flush': 9,
  'Four of a Kind': 8,
  'Full House': 7,
  'Flush': 6,
  'Straight': 5,
  'Three of a Kind': 4,
  'Two Pair': 3,
  'Pair': 2,
  'High Card': 1,
};
